<template>
  <div id="container" style="margin: 0;height: 100%;"></div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader';

let interval = null;

export default {
  data() {
    return {
      map: null,
      AMap: null,
      license: '',
      marker: null,      // 当前车辆标记
      infoWindow: null,  // 信息窗体
    };
  },
  methods: {
    /**
     * 初始化车辆标记
     */
    initMarker({ x, y, text = '冀J12345', data }) {
      const { 
        driver, escort, speed, mileage, month_mileage, 
        formatted_address, direct, type 
      } = data;

      const marker = new this.AMap.Marker({
        position: new this.AMap.LngLat(x, y),
        title: text,
        offset: new this.AMap.Pixel(0, 16),
      });

      marker['license'] = text;
      marker['x'] = x;
      marker['y'] = y;

      // 计算今日里程
      const lc = Math.floor(mileage - month_mileage);

      // 构建弹窗内容（司机/押运员为空时隐藏）
      let bosHtml = '';
      
      // 司机和押运员在同一行，都为空则整行隐藏
      if (driver || escort) {
        bosHtml += `<div class="item">`;
        if (driver) bosHtml += `<div class="dir">司机:${driver}</div>`;
        if (escort) bosHtml += `<div class="esp">押运员:${escort}</div>`;
        bosHtml += `</div>`;
      }
      
      if (speed !== undefined && speed !== null && speed !== '') {
        bosHtml += `<div class="item"><div class="dir">实时车速:${speed}km/h</div></div>`;
      }
      
      if (lc > 0) {
        bosHtml += `<div class="item"><div class="dir">今日里程:${lc}km</div></div>`;
      }
      
      if (formatted_address) {
        bosHtml += `<div class="item"><div class="dir">实时位置:${formatted_address}</div></div>`;
      }

      marker.setContent(`
        <div class="marker">
          <div class="tit">
            <div class="top">
              <div class="lic">${text}</div>
              <div class="logo"></div>
            </div>
            <div class="hx"></div>
            <div class="bos">
              ${bosHtml}
            </div>
            <div class="after"></div>
          </div>
          <div class="cont ${type === '在线' ? '' : 'off'}" id="mark${text}" style="transform:rotate(${90 + direct}deg);"></div>
        </div>
      `);

      // 构建信息窗体内容
      const infoContent = [];
      if (driver) infoContent.push(`司机：${driver}`);
      if (escort) infoContent.push(`押运员：${escort}`);
      if (speed !== undefined && speed !== null && speed !== '') infoContent.push(`实时速度：${speed}km/h`);
      if (lc > 0) infoContent.push(`今日里程：${lc}km`);
      if (formatted_address) infoContent.push(`实时位置：${formatted_address}`);
      if (data.gpstime) infoContent.push(`时间：${data.gpstime}`);
      if (data.state2) infoContent.push(`状态：${data.state2}`);

      // 创建信息窗体
      this.infoWindow = new this.AMap.InfoWindow({
        isCustom: true,
        content: this.createInfoWindow(text, infoContent.join('<br/>')),
        offset: new this.AMap.Pixel(16, -45),
      });

      // 标记点击事件：显示信息窗体
      // marker.on('click', () => {
      //   this.showAllLisence();
      //   this.infoWindow.open(this.map, marker.getPosition());
      // });

      // 车辆图标点击事件（点击车标展开详情）
      // 使用 setTimeout 确保 DOM 渲染完成
      setTimeout(() => {
        // const markEl = document.querySelector(`#mark${text}`);
        // if (markEl) {
        //   const self = this;
        //   markEl.onclick = function(e) {
        //     e.stopPropagation();
        //     self.showAllLisence();
        //     // 隐藏当前标记的文字部分
        //     const tit = this.previousElementSibling;
        //     if (tit) tit.classList.add('hide');
        //     self.infoWindow.open(self.map, marker.getPosition());
        //   };
        // }
      }, 50);

      this.map.add(marker);
      this.marker = marker;

      return marker;
    },

    /**
     * 构建自定义信息窗体
     */
    createInfoWindow(title, content) {
      const info = document.createElement('div');
      info.className = 'custom-info input-card content-window-card';

      // 顶部
      const top = document.createElement('div');
      top.className = 'info-top';
      const titleD = document.createElement('div');
      titleD.innerHTML = title;
      const closeX = document.createElement('img');
      closeX.src = 'https://webapi.amap.com/images/close2.gif';
      closeX.onclick = this.closeInfoWindow;
      closeX.style.cursor = 'pointer';
      top.appendChild(titleD);
      top.appendChild(closeX);
      info.appendChild(top);

      // 中部内容
      const middle = document.createElement('div');
      middle.className = 'info-middle';
      middle.style.backgroundColor = 'white';
      middle.innerHTML = content;
      info.appendChild(middle);

      // 底部
      const bottom = document.createElement('div');
      bottom.className = 'info-bottom';
      const sharp = document.createElement('img');
      sharp.src = 'https://webapi.amap.com/images/sharp.png';
      bottom.appendChild(sharp);
      info.appendChild(bottom);

      return info;
    },

    /**
     * 关闭信息窗体
     */
    closeInfoWindow() {
      if (this.map) {
        this.map.clearInfoWindow();
      }
      this.showAllLisence();
    },

    /**
     * 显示所有车牌标签
     */
    showAllLisence() {
      const hides = document.querySelectorAll('.marker .hide');
      hides.forEach(el => el.classList.remove('hide'));
    },

    /**
     * 获取车辆位置数据
     */
    getData(isRefresh) {
      this.post(`car/locationinfo`, { license: this.license }, res => {
        console.log('位置数据:', res);
        if (res.msg !== 'success') {
          this.$message({
            type: 'error',
            message: '获取数据失败，请稍后重试！',
          });
          return;
        }

        const data = res.data;
        if (!data) return;

        const { longitude, latitude } = data;

        // 如果是刷新且存在旧标记，先移除
        if (isRefresh && this.marker) {
          this.marker.setMap(null);
          this.marker = null;
        }

        // 如果设备离线
        if (data.type === '离线') {
          this.$message({
            type: 'warning',
            message: '设备已离线',
          });
          // 仍然显示离线标记，但不继续轮询？根据需求决定
        }

        if (longitude && latitude) {
          // 设置地图中心
          this.map.setCenter([longitude, latitude]);
          // 创建新标记
          this.initMarker({
            x: longitude,
            y: latitude,
            text: this.license,
            data: data,
          });
        }
      }, err => {
        console.error('请求失败:', err);
        clearInterval(interval);
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！',
        });
      });
    },
  },
  mounted() {
    const { license } = this.$route.query;
    this.license = license || '';

    AMapLoader.load({
      key: '0faeff35413697ab916e270235874fc9',
      version: '2.0',
    })
      .then((AMap) => {
        this.map = new AMap.Map('container', {
          center: [117.317026, 38.359087],
          zoom: 15,
        });
        this.AMap = AMap;
        this.$nextTick(() => {
          this.getData(false);
        });
        // 每30秒刷新一次
        interval = setInterval(() => {
          this.getData(true);
        }, 30000);
      })
      .catch((e) => {
        console.error('高德地图加载失败:', e);
      });
  },
  beforeDestroy() {
    clearInterval(interval);
    if (this.map) {
      this.map.destroy();
      this.map = null;
    }
  },
  // Vue 2 路由离开守卫
  beforeRouteLeave(to, from, next) {
    clearInterval(interval);
    next();
  },
};
</script>

<style lang="less" scoped>
#container {
  width: 100%;
  height: 100%;

  /deep/ .marker {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;

    .tit {
      background-color: #fff;
      color: #404040;
      font-weight: 400;
      font-size: 12px;
      border-radius: 5px;
      width: 185px;
      margin-bottom: 8px;
      position: relative;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

      .top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px 15px;

        .lic {
          font-weight: bold;
          font-size: 14px;
          color: #404040;
        }

        .logo {
          background: url(../../../assets/img/pos_icon1.png) no-repeat;
          background-size: 100%;
          width: 31px;
          height: 30px;
        }
      }

      .hx {
        width: 100%;
        height: 1px;
        background: #e5e5e5;
      }

      .bos {
        padding: 0 15px 12px;

        .item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 8px;
          font-size: 12px;
          color: #404040;

          .dir,
          .esp {
            font-size: 12px;
            color: #404040;
          }
        }
      }

      &.hide {
        visibility: hidden;
      }

      .after {
        content: '';
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        border: 5px solid transparent;
        border-top-color: #fff;
      }
    }

    .cont {
      width: 55px;
      height: 55px;
      background: url(../../../assets/img/fleet01.png) no-repeat center center;
      background-size: 100%;
      margin-top: -5px;
      cursor: pointer;

      &.off {
        background-image: url(../../../assets/img/fleet01_off.png);
      }
    }
  }

  /deep/ .custom-info {
    border: solid 1px silver;

    &.content-window-card {
      position: relative;
      box-shadow: none;
      bottom: 0;
      left: 0;
      width: auto;
      padding: 0;

      .info-top {
        position: relative;
        background: #f9f9f9;
        border-bottom: 1px solid #ccc;
        border-radius: 5px 5px 0 0;

        div {
          display: inline-block;
          color: #333;
          font-size: 14px;
          font-weight: bold;
          line-height: 31px;
          padding: 0 10px;
        }

        img {
          position: absolute;
          top: 10px;
          right: 10px;
          transition-duration: 0.25s;

          &:hover {
            box-shadow: 0 0 5px #000;
          }
        }
      }

      .info-middle {
        font-size: 12px;
        padding: 10px 12px;
        line-height: 22px;
        min-width: 140px;
      }

      .info-bottom {
        height: 0;
        width: 100%;
        clear: both;
        text-align: center;

        img {
          position: relative;
          z-index: 104;
        }
      }
    }
  }
}
</style>